import React from 'react';

interface SubMenuProps {
  items: { key: string; label: string }[];
  active: string;
  onChange: (_key: string) => void;
}

export const SubMenu: React.FC<SubMenuProps> = ({ items, active, onChange }) => {
  return (
    <div className="flex flex-col w-60 bg-white shadow-md">
      <div className="flex p-3 border-b border-b-gray-125">Policies</div>
      {items.map((item) => (
        <button
          key={item.key}
          onClick={() => onChange(item.key)}
          className={`text-sm text-left p-2 border-l-4 border-b border-b-gray-125 hover:bg-red-300 hover:bg-opacity-5 ${
            active === item.key ? 'border-red font-bold' : 'border-transparent'
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default SubMenu;
